import { useGetTodosQuery, useAddTodoMutation } from "./todoApiSlice"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpload, faCalendar } from '@fortawesome/free-solid-svg-icons'
import { useState,  useEffect } from "react"
import useAuth from "../../hooks/useAuth"
import Todo from './Todo'
import { toast } from 'react-toastify'
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { getDate, isMobileDevice } from '../../config/functions'


const TodoList = () => {
    useTitle('DPE: ToDo list')
    const isMobile=isMobileDevice()

    const { userId, username, isAdmin } = useAuth()

    const [newTodo, setNewTodo] = useState('')
    const [userID] = useState(userId)
    const [dueDate, setdueDate] = useState(getDate('y-m-d'))

    const [filterCompleted, setFilterCompleted] = useState(true)
    const onCompletedChanged = () => {
        setFilterCompleted(prev => !prev)
    }
    const [filterAdmin, setFilterAdmin] = useState(true)
    const onAdminChanged = () => {
        setFilterAdmin(prev => !prev)
    }

    const {
        data: todos,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetTodosQuery('todoList')

    const [addTodo, {
        isError: isErrorAdd,
        error: errorAdd
    }] =  useAddTodoMutation()

    useEffect(() => {

        if (isError) {
            toast.error(error?.data?.message);
        }
        if (isErrorAdd) {
            toast.error(errorAdd?.data?.message);
        }
        
    }, [isErrorAdd, errorAdd, isError, error])
    


    const onSaveTodoClicked = async (e) => {
        e.preventDefault()
        addTodo({ user: userID, title: newTodo, completed: false, duedate:dueDate })
        setNewTodo('')
    }

    const newItemSection = (
        <div className="row mb-5 g-0">
            <div className="col-md-5">
                <input
                    type="text"
                    id="new-todo"
                    className="form-control"
                    value={newTodo}
                    onChange={(e) => setNewTodo(e.target.value)}
                    placeholder="Enter new todo"
                />
            </div>
            <div className="col-md-3">
                <input
                    type="date"
                    id="duedate"
                    name="duedate"
                    className="form-control"
                    value={dueDate}
                    onChange={(e) => setdueDate(e.target.value)}
                />
            </div>
            <div className="col-md-2 mt-2 text-end">
                <span
                    role="button"
                    title="Create new ToDo"
                    className="text-success p-2 icon"
                    onClick={onSaveTodoClicked}
                >
                    Create
                    <FontAwesomeIcon icon={faUpload} className="fa-icon"/>
                </span>
            </div>
        </div>
    )

    let filterSection = null
    if (isAdmin && !isMobile) {
        filterSection = (
            <div className="row g-0">
                <div className="col-md-8 text-end"><br /></div>
                <div className="col-md-4 text-end border border-3 p-2 rounded">
                    <label style={{float: "left"}}>Show </label>
                    <label htmlFor="filter">All</label>
                    <input type="checkbox" id="filter" name="filter" className="table-input" checked={filterCompleted} onChange={onCompletedChanged} style={{marginRight:"20px"}}/>

                    <label htmlFor="admin">Admin Only</label>
                    <input type="checkbox" id="admin" name="admin" className="table-input" checked={filterAdmin} onChange={onAdminChanged} />
                </div>
            </div>
        )
    } 


    let content;
    if (isLoading) {
        content = <PulseLoader color={"#5f788a"} />
    } else if (isSuccess) {

        // filter records
        const { ids, entities } = todos
        let filteredIds=null

        if (isAdmin) {
            if (filterCompleted===false) {
                if (filterAdmin) {
                    // show admin records only, that are not completed
                    filteredIds = ids.filter(todoId => entities[todoId].username === username && entities[todoId].completed === false)
                } else {
                    // show all record, that are not completed
                    filteredIds = ids.filter(todoId => entities[todoId].completed === false)
                }
            } else {
                if (filterAdmin) {
                    //show admin records only, completed and non-completed
                    filteredIds = ids.filter(todoId => entities[todoId].username === username)
                } else {
                    // show all records, completed and non-completed
                    filteredIds = [...ids]
                }
                
            }
        
        } else {
            // show all todos, completed ot not.
            //filteredIds = ids.filter(todoId => entities[todoId].username === username && entities[todoId].completed === false)  
            filteredIds = ids.filter(todoId => entities[todoId].username === username)  
        }
        
        let tableContent=null
        if (filteredIds.length) {
            tableContent = filteredIds.map(todoId => <Todo key={todoId} todoId={todoId} isMobile={isMobile} isAdmin={isAdmin} />)
        }

        let tableHeader=null
        if (isMobile) {
            tableHeader=(
                <tr>
                    <th>Title</th>
                </tr>
            )
        } else {
            if (isAdmin) {
                tableHeader= (
                    <tr>
                        <th>Status</th>
                        <th>Title</th>
                        <th>DueDate</th>
                        <th>User</th>
                        <th></th>
                    </tr>
                )
            } else {
                tableHeader= (
                    <tr>
                        <th>Status</th>
                        <th>Title</th>
                        <th>DueDate</th>
                        <th></th>
                    </tr>
                )
            }
        }


        content = (
            <section id="main_content">
                <header>
                    <h1 className="text-steel mt-5"><FontAwesomeIcon icon={faCalendar} style={{fontSize:"30px", marginRight:"5px"}}/>ToDo List</h1>
                </header>
                <main>
                    <div className="mt-3">
                        {newItemSection}
                        {filterSection}
                        <table className="table table-striped">
                            <thead>
                                {tableHeader}
                            </thead>
                            <tbody>
                                {tableContent}
                            </tbody>
                        </table>
                    </div>
                </main>
            </section>
        )
    }

    return content
}
export default TodoList